import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  useLocation,
} from "react-router-dom";
import * as Sentry from "@sentry/browser";

import Loader from "./components/loader";
import Layout from "./components/Layout";

import Auth from "./scenes/auth";
import Dashboard from "./scenes/dashboard";
import Account from "./scenes/account";
import User from "./scenes/user";
import Code from "./scenes/code";
// import Report from "./scenes/report";

import api from "./services/api";
import { setUser } from "./redux/auth/actions";

import { ENVIRONMENT, SENTRY_URL } from "./config";

import "./index.css";

if (ENVIRONMENT === "production" && SENTRY_URL)
  Sentry.init({ dsn: SENTRY_URL, environment: "app" });

const App = () => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await api.get("/admin/signin_token");
        if (!res.ok || !res.user) return setLoading(false);
        if (res.token) api.setToken(res.token);
        dispatch(setUser(res.user));
      } catch (e) {
        console.log(e);
      }
      setLoading(false);
    }
    fetchData();
  }, []);

  if (loading) return <Loader />;

  return (
    <Router>
      <ScrollToTop />
      <Switch>
        <Route path="/auth" component={Auth} />
        <Layout className="w-full">
          <RestrictedRoute path="/user" component={User} />
          <RestrictedRoute path="/code" component={Code} />
          {/* <RestrictedRoute path="/report" component={Report} /> */}
          <RestrictedRoute path="/account" component={Account} />
          <RestrictedRoute exact path="/" component={Dashboard} />
        </Layout>
      </Switch>
    </Router>
  );
};

const RestrictedRoute = ({ component: Component, role, ...rest }) => {
  const user = useSelector((state) => state.Auth.user);

  if (!user || (role === "admin" && user.role !== "admin"))
    return <Redirect to={{ pathname: "/auth" }} />;

  return (
    <Route
      {...rest}
      render={(props) =>
        user ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: "/auth" }} />
        )
      }
    />
  );
};

export default App;

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
